/**
 * icon.web.js
 * Bottom Tab Icons – Screenshot Matched (PWA)
 */

import React from 'react';
import { View } from 'react-native';

const Icon = ({ name, size = 24, color = '#9CA3AF', style }) => {

  const getIcon = () => {
    switch (name) {
      /* ================= WITHDRAW (ARROW UP CIRCLE) ================= */
      case 'arrow-up-circle':
      case 'arrow-up-circle-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" fill="none" />
            <path d="M12 16V8" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path d="M8 12L12 8L16 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        );

      /* ================= QUOTES ================= */
      case 'swap-vertical':
      case 'swap-vertical-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path
              d="M8 16 L8 8 M5 11 L8 8 L11 11"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16 8 L16 16 M13 13 L16 16 L19 13"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );

      /* ================= CHARTS (CANDLESTICK) ================= */
      case 'bar-chart':
      case 'bar-chart-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            {/* Left candle */}
            <line x1="8" y1="4" x2="8" y2="20" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <rect x="6.5" y="8" width="3" height="8" rx="1" stroke={color} strokeWidth="2" fill="none" />

            {/* Right candle */}
            <line x1="16" y1="4" x2="16" y2="20" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <rect x="14.5" y="6" width="3" height="10" rx="1" stroke={color} strokeWidth="2" fill="none" />
          </svg>
        );

      /* ================= TRADES ================= */
      case 'git-network':
      case 'git-network-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path
              d="M4 17 L9 11 L14 14 L20 7"
              stroke={color}
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="4" cy="17" r="2.5" fill={color} />
            <circle cx="9" cy="11" r="2.5" fill={color} />
            <circle cx="14" cy="14" r="2.5" fill={color} />
            <circle cx="20" cy="7" r="2.5" fill={color} />
          </svg>
        );

      /* ================= HISTORY ================= */
      case 'reload-circle':
      case 'reload-circle-outline':
        return (
          <svg 
            width={size} 
            height={size} 
            viewBox="0 0 24 24" 
            fill="none"
            stroke={color}
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            {/* Circular Arrow */}
            <path d="M3 12a9 9 0 1 0 3-6.7" />
            <polyline points="3 4 3 10 9 10" />

            {/* Clock Hands */}
            <line x1="12" y1="7" x2="12" y2="12" />
            <line x1="12" y1="12" x2="15" y2="14" />
          </svg>
        );

      /* ================= SETTINGS ================= */
      case 'settings':
      case 'settings-outline':
        return (
          <svg 
            width={size} 
            height={size} 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke={color}
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c0 .67.39 1.27 1 1.51H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
          </svg>
        );

      /* ================= CHECKMARK CIRCLE ================= */
      case 'checkmark-circle':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" fill={color} />
            <path
              d="M8 12 L11 15 L16 9"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );

      /* ================= SHIELD CHECKMARK ================= */
      case 'shield-checkmark':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path
              d="M12 3 L5 6 L5 11 C5 15.5 8 19.5 12 21 C16 19.5 19 15.5 19 11 L19 6 L12 3 Z"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
            <path
              d="M9 12 L11 14 L15 10"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );

      /* ================= COMMON ICONS ================= */
      case 'wallet':
      case 'wallet-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="3" y="6" width="18" height="14" rx="2" stroke={color} strokeWidth="2" />
            <path d="M3 10 L21 10" stroke={color} strokeWidth="2" />
            <circle cx="17" cy="14" r="1.5" fill={color} />
          </svg>
        );

      case 'book':
      case 'book-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path 
              d="M12 6.5 C12 6.5 9 4 6 4 C3 4 2 5 2 6.5 L2 18.5 C2 18.5 3 17.5 6 17.5 C9 17.5 12 20 12 20 M12 6.5 C12 6.5 15 4 18 4 C21 4 22 5 22 6.5 L22 18.5 C22 18.5 21 17.5 18 17.5 C15 17.5 12 20 12 20 M12 6.5 L12 20"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );

      case 'create':
      case 'create-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="4" y="4" width="13" height="13" rx="2" stroke={color} strokeWidth="2" />
            <path d="M14 4 L20 4 L20 10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <line x1="20" y1="4" x2="11" y2="13" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'call':
      case 'call-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path 
              d="M21 15.92 C21 16.32 20.92 16.73 20.75 17.11 C20.58 17.49 20.35 17.85 20.04 18.18 C19.55 18.72 19.01 19.1 18.4 19.32 C17.8 19.54 17.15 19.65 16.45 19.65 C15.43 19.65 14.34 19.41 13.19 18.92 C12.04 18.43 10.89 17.77 9.75 16.94 C8.6 16.1 7.51 15.18 6.47 14.17 C5.44 13.15 4.51 12.07 3.68 10.94 C2.86 9.81 2.2 8.67 1.72 7.54 C1.24 6.4 1 5.32 1 4.3 C1 3.61 1.1 2.96 1.31 2.37 C1.52 1.77 1.86 1.22 2.35 0.73 C2.95 0.11 3.61 -0.19 4.32 -0.19 C4.61 -0.19 4.9 -0.13 5.16 -0.01 C5.43 0.11 5.66 0.29 5.84 0.55 L8.39 4.01 C8.57 4.26 8.7 4.49 8.79 4.71 C8.88 4.92 8.93 5.13 8.93 5.32 C8.93 5.56 8.86 5.8 8.72 6.03 C8.59 6.26 8.4 6.5 8.16 6.74 L7.4 7.53 C7.29 7.64 7.24 7.77 7.24 7.93 C7.24 8.01 7.25 8.08 7.27 8.16 C7.3 8.24 7.33 8.3 7.35 8.36 C7.53 8.69 7.84 9.12 8.28 9.64 C8.73 10.16 9.21 10.69 9.73 11.22 C10.27 11.75 10.79 12.24 11.32 12.69 C11.84 13.13 12.27 13.43 12.61 13.61 C12.66 13.63 12.72 13.66 12.79 13.69 C12.87 13.72 12.95 13.73 13.04 13.73 C13.21 13.73 13.34 13.67 13.45 13.56 L14.21 12.81 C14.46 12.56 14.7 12.37 14.93 12.25 C15.16 12.11 15.39 12.04 15.64 12.04 C15.83 12.04 16.03 12.08 16.25 12.17 C16.47 12.26 16.7 12.39 16.95 12.56 L20.45 15.14 C20.71 15.32 20.89 15.53 21 15.79 C21.1 16.05 21.15 16.31 21.15 16.6 Z"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );

      case 'person':
      case 'person-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="7" r="4" stroke={color} strokeWidth="2" />
            <path d="M5 20 C5 16 8 14 12 14 C16 14 19 16 19 20" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'mail':
      case 'mail-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="3" y="5" width="18" height="14" rx="2" stroke={color} strokeWidth="2" />
            <path d="M3 7 L12 13 L21 7" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'lock-closed':
      case 'lock-closed-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="5" y="11" width="14" height="10" rx="2" stroke={color} strokeWidth="2" />
            <path d="M8 11 L8 7 C8 4.8 9.8 3 12 3 C14.2 3 16 4.8 16 7 L16 11" stroke={color} strokeWidth="2" />
          </svg>
        );

      case 'eye':
      case 'eye-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M2 12 C2 12 5 5 12 5 C19 5 22 12 22 12 C22 12 19 19 12 19 C5 19 2 12 2 12 Z" stroke={color} strokeWidth="2" />
            <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="2" />
          </svg>
        );

      case 'eye-off':
      case 'eye-off-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M3 3 L21 21" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path d="M10.5 10.5 C10 11 9.5 11.5 9.5 12.5 C9.5 14 10.5 15 12 15 C13 15 13.5 14.5 14 14" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path d="M6.5 6.5 C4 8 2 12 2 12 C2 12 5 19 12 19 C14 19 15.5 18.5 17 17.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path d="M19.5 16 C21 14.5 22 12 22 12 C22 12 19 5 12 5 C11 5 10 5.5 9 6" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'chevron-back':
      case 'chevron-back-outline':
      case 'arrow-back':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M15 18 L9 12 L15 6" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        );

      case 'chevron-forward':
      case 'chevron-forward-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M9 6 L15 12 L9 18" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        );

      case 'arrow-down':
      case 'arrow-down-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M12 5 L12 19 M6 13 L12 19 L18 13" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        );

      case 'menu':
      case 'menu-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M3 6 L21 6 M3 12 L21 12 M3 18 L21 18" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'close':
      case 'close-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M6 6 L18 18 M18 6 L6 18" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
          </svg>
        );

      case 'search':
      case 'search-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke={color} strokeWidth="2" />
            <path d="M16 16 L21 21" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
          </svg>
        );

      case 'add':
      case 'add-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M12 5 L12 19 M5 12 L19 12" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
          </svg>
        );

      case 'chart-line-variant':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M3 14 L7 10 L11 14 L21 4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M21 4 L21 9 M21 4 L16 4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        );

      case 'animation-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            {/* Back layer */}
            <rect x="4" y="8" width="12" height="12" rx="1.5" stroke={color} strokeWidth="2" fill="none" />
            {/* Middle layer */}
            <rect x="6" y="6" width="12" height="12" rx="1.5" stroke={color} strokeWidth="2" fill="none" />
            {/* Front layer */}
            <rect x="8" y="4" width="12" height="12" rx="1.5" stroke={color} strokeWidth="2" fill="none" />
          </svg>
        );

      case 'key':
      case 'key-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="7" cy="17" r="4" stroke={color} strokeWidth="2" />
            <path d="M11 14 L21 4 M15 4 L21 4 L21 10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        );

      case 'people':
      case 'people-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="9" cy="7" r="3" stroke={color} strokeWidth="2" />
            <circle cx="16" cy="9" r="3" stroke={color} strokeWidth="2" />
            <path d="M3 20 C3 16.5 5.5 14 9 14 C10 14 11 14.2 11.8 14.6" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path d="M12 20 C12 17 14 15 16 15 C18 15 20 17 20 20" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'add-circle':
      case 'add-circle-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" />
            <path d="M12 7 L12 17 M7 12 L17 12" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'remove-circle':
      case 'remove-circle-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" />
            <path d="M7 12 L17 12" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'moon':
      case 'moon-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M21 12.79 C20.34 13.57 19.5 14.21 18.56 14.65 C17.61 15.09 16.58 15.32 15.53 15.32 C12.26 15.32 9.61 12.67 9.61 9.4 C9.61 8.35 9.84 7.32 10.28 6.37 C10.72 5.43 11.36 4.59 12.14 3.93 C6.64 4.54 2.5 9.23 2.5 14.89 C2.5 20.92 7.08 25.5 13.11 25.5 C18.77 25.5 23.46 21.36 24.07 15.86 C23.41 16.23 22.71 16.52 21.98 16.72 C21.66 15.46 21.39 14.13 21 12.79 Z" stroke={color} strokeWidth="2" strokeLinejoin="round" />
          </svg>
        );

      case 'shield':
      case 'shield-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M12 3 L5 6 L5 11 C5 15.5 8 19.5 12 21 C16 19.5 19 15.5 19 11 L19 6 L12 3 Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        );

      case 'business':
      case 'business-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="4" y="7" width="16" height="14" rx="1" stroke={color} strokeWidth="2" />
            <path d="M8 7 L8 5 C8 3.9 8.9 3 10 3 L14 3 C15.1 3 16 3.9 16 5 L16 7" stroke={color} strokeWidth="2" />
            <path d="M4 11 L20 11" stroke={color} strokeWidth="2" />
          </svg>
        );

      case 'code':
      case 'code-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M8 8 L4 12 L8 16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 8 L20 12 L16 16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        );

      case 'phone-portrait':
      case 'phone-portrait-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="6" y="2" width="12" height="20" rx="2" stroke={color} strokeWidth="2" />
            <path d="M10 18 L14 18" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'card':
      case 'card-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="2" y="6" width="20" height="12" rx="2" stroke={color} strokeWidth="2" />
            <path d="M2 10 L22 10" stroke={color} strokeWidth="2" />
          </svg>
        );

      case 'cash':
      case 'cash-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="2" y="7" width="20" height="10" rx="2" stroke={color} strokeWidth="2" />
            <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="2" />
          </svg>
        );

      case 'time':
      case 'time-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2" />
            <path d="M12 7 L12 12 L15 15" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'calendar':
      case 'calendar-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="4" y="5" width="16" height="16" rx="2" stroke={color} strokeWidth="2" />
            <path d="M4 9 L20 9" stroke={color} strokeWidth="2" />
            <path d="M8 3 L8 7 M16 3 L16 7" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'document-text':
      case 'document-text-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M14 2 L6 2 C4.9 2 4 2.9 4 4 L4 20 C4 21.1 4.9 22 6 22 L18 22 C19.1 22 20 21.1 20 20 L20 8 Z" stroke={color} strokeWidth="2" />
            <path d="M14 2 L14 8 L20 8" stroke={color} strokeWidth="2" strokeLinejoin="round" />
            <path d="M8 12 L16 12 M8 16 L16 16" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'image':
      case 'image-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke={color} strokeWidth="2" />
            <circle cx="8.5" cy="8.5" r="2" stroke={color} strokeWidth="2" />
            <path d="M21 15 L16 10 L6 20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        );

      case 'notifications':
      case 'notifications-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M10 5 C10 3.9 10.9 3 12 3 C13.1 3 14 3.9 14 5 C16.2 6.2 18 8.4 18 11 L18 16 L21 19 L3 19 L6 16 L6 11 C6 8.4 7.8 6.2 10 5 Z" stroke={color} strokeWidth="2" strokeLinejoin="round" />
            <path d="M10 20 C10 21.1 10.9 22 12 22 C13.1 22 14 21.1 14 20" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'help-circle':
      case 'help-circle-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" />
            <path d="M9.5 9 C9.5 7.6 10.6 6.5 12 6.5 C13.4 6.5 14.5 7.6 14.5 9 C14.5 10.4 13.4 11.5 12 11.5 L12 13.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <circle cx="12" cy="17" r="0.5" fill={color} stroke={color} strokeWidth="1" />
          </svg>
        );

      case 'information-circle':
      case 'information-circle-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" />
            <path d="M12 16 L12 11" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <circle cx="12" cy="8" r="0.5" fill={color} stroke={color} strokeWidth="1" />
          </svg>
        );

      case 'trash':
      case 'trash-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M3 6 L21 6" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path d="M8 6 L8 4 C8 2.9 8.9 2 10 2 L14 2 C15.1 2 16 2.9 16 4 L16 6" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path d="M19 6 L19 20 C19 21.1 18.1 22 17 22 L7 22 C5.9 22 5 21.1 5 20 L5 6" stroke={color} strokeWidth="2" />
          </svg>
        );

      case 'share':
      case 'share-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="18" cy="5" r="3" stroke={color} strokeWidth="2" />
            <circle cx="6" cy="12" r="3" stroke={color} strokeWidth="2" />
            <circle cx="18" cy="19" r="3" stroke={color} strokeWidth="2" />
            <path d="M8.5 13.5 L15.5 17.5 M15.5 6.5 L8.5 10.5" stroke={color} strokeWidth="2" />
          </svg>
        );

      case 'log-out':
      case 'log-out-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M9 21 L5 21 C3.9 21 3 20.1 3 19 L3 5 C3 3.9 3.9 3 5 3 L9 3" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path d="M16 17 L21 12 L16 7" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M21 12 L9 12" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'download':
      case 'download-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M12 3 L12 15 M8 11 L12 15 L16 11" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 15 L3 19 C3 20.1 3.9 21 5 21 L19 21 C20.1 21 21 20.1 21 19 L21 15" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'cloud-upload':
      case 'cloud-upload-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M7 18 C4.2 18 2 15.8 2 13 C2 10.2 4.2 8 7 8 C7 5.2 9.2 3 12 3 C14.8 3 17 5.2 17 8 C19.8 8 22 10.2 22 13 C22 15.8 19.8 18 17 18" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path d="M12 12 L12 21 M9 18 L12 21 L15 18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        );

      case 'copy':
      case 'copy-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="9" y="9" width="13" height="13" rx="2" stroke={color} strokeWidth="2" />
            <path d="M5 15 L5 5 C5 3.9 5.9 3 7 3 L17 3" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case 'checkmark':
      case 'checkmark-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M5 12 L10 17 L20 7" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        );

      case 'trending-up':
      case 'trending-up-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M3 17 L9 11 L13 15 L21 7" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 7 L21 7 L21 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        );

      case 'newspaper':
      case 'newspaper-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="14" height="18" rx="2" stroke={color} strokeWidth="2" />
            <path d="M7 7 L13 7 M7 11 L13 11 M7 15 L10 15" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path d="M17 5 L17 19 C17 20.1 17.9 21 19 21 C20.1 21 21 20.1 21 19 L21 7 C21 5.9 20.1 5 19 5 L17 5" stroke={color} strokeWidth="2" />
          </svg>
        );

      case 'code-slash':
      case 'code-slash-outline':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M8 8 L4 12 L8 16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 8 L20 12 L16 16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 4 L10 20" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      default:
        return null;
    }
  };

  return (
    <View
      style={[
        {
          width: size,
          height: size,
          alignItems: 'center',
          justifyContent: 'center',
        },
        style,
      ]}
    >
      {getIcon()}
    </View>
  );
};

export default Icon;
